<template>
	<div class="form pb20" id="fourth_step" style="margin: 0" v-if="loaded">
			<div class="step_title" v-html="words.step+' '+ step"></div>
			<h2 class="title" v-html="words.where_to_send_invoice"></h2>
			<form class="" @submit.prevent="openUser()">
				<div class="invoice_wrapper">
					<div :class="'option '+(form.invoice == '0' ? 'active' : '')" @click="form.invoice = 0">
						<div class="small_title bold" v-html="words.by_email"></div>
						<div class="radio"></div>
						<div class="value semi_bold">
							{{ email }} <a class="change_number semi_bold" @click.stop="$emit('goToStep', 2)" v-html="words.change_number"></a>
						</div>
					</div>
					<div :class="'option '+(form.invoice == '1' ? 'active' : '')" @click="form.invoice = 1">
						<div class="small_title bold" v-html="words.by_user_area"></div>
						<div class="radio"></div>
					</div>
				</div>
				<div class="terms">
					<h4 class="inner_title" v-html="words.read_terms"></h4>
					<div class="pdf_wrapper">
						<div v-html="terms"></div>
					</div>
					<div class="sig_wrapper">
					<h4 class="inner_title" v-html="words.sign_terms"></h4>
					<SignaturePad :width="300" :height="100"  @input="singChange" :customStyle="sigPadStyle" ref="signaturePad"  />
					<div class="sig_controls">
						<a @click="clearSig" class="btn_clear_sig" v-html="words.clear_signature"></a>
					</div>
					</div>
				</div>		
				<div class="btn_wrapper">
					<a class="go_back under_line" @click="$emit('returnStep')" tabindex="0" v-html="words.return_step"></a>
					<input :disabled="!isOkToSubmit" type="submit" :class="'btn '+ (isOkToSubmit ? '' : 'disabled')" :value="words.procced">
				</div>
			</form>
	</div>
</template>

<script>

export default {
  data() {
    return {
		form:{
			invoice: 0 // invoice sending method, 0 = email, 1 = user area
		},
		isLoading: false,
		terms: '',
		isOkToSubmit:false,
		loaded:false,
		numOfPages: 0,
		sigPadStyle: {border: 'black 1px solid', marginTop: '5px' }
	}
  },
  props: {
    numbersInfo: {
      required: true,
      type: Array,
    },
    step: {
      required: true,
      type: Number,
    },
    numbers: {
      required: true,
      type: Array,
    },
    skipPay: {
      required: true,
      type: Boolean,
    },
    phone: {
      required: true,
      type: String,
    },
    email: {
      required: true,
      type: String,
    },
  },
  mounted(){
	this.$store.commit('setIsLoading', {isLoading: true});

	this.api({ action: 'get_terms', data: { } }, (data) => {
		this.terms = data.data.text;
		this.loaded = true;
		this.$store.commit('setIsLoading', {isLoading: false});

	});
  },
  computed: {
    words() {
      return this.$store.state.words
    }
  },
  methods: {
	urltoFile(url, filename, mimeType){
    mimeType = mimeType || (url.match(/^data:([^;]+);/)||'')[1];
    return (fetch(url)
        .then(function(res){return res.arrayBuffer();})
        .then(function(buf){return new File([buf], filename, {type:mimeType});})
    );
},
	onSelectCity() {
		this.openStreet = true;
		this.api({action: 'cart/save_city',data: { city: this.selectedCity }});
	},
	singChange() {
		this.isOkToSubmit = true;
	},
	openUser() {
			this.$store.commit('setIsLoading', {isLoading: true});
			console.log(this.$refs.signaturePad);
			if (this.$refs.signaturePad.isEmpty()) this.activateError(this.words.signature_requierd)
			else {
				const { data } = this.$refs.signaturePad.saveSignature();
				const formData = {signature: data, ...this.form}
				console.log(formData);
				this.$emit('saveData',formData, true);
				// if(this.skipPay) return this.saveDidsToAccount();
				this.api({ action: 'api/add_account', data: { } }, (data) => {
					if(data.data.error && data.data.error != "") {
						this.activateError(data.data.error);
						return this.$store.commit('setIsLoading', {isLoading: false});
					}
					else if(data.data && !this.skipPay) {
						this.$emit('goToStep', this.step + 1);window.scrollTo(0,0); 
					}
				});
			}
			this.$store.commit('setIsLoading', {isLoading: false});
			
	},
	saveDidsToAccount() {
			const { data } = this.$refs.signaturePad.saveSignature();
			const formData = {signature: data}
			this.$emit('saveData',formData, true);
			this.api({ action: 'api/save_dids_to_account'}, (data)=>{
			if(data.data.error && data.data.error != "") {
			this.activateError(data.data.error);
			this.$store.commit('setIsLoading', {isLoading: false});
			} else document.location = '/activate';

			this.$emit('saveData',false);
			})
	},
	clearSig() {
		this.$refs.signaturePad.clearSignature();
		this.isOkToSubmit = false;
    },
  },
  watch:{
		isOkToSubmit(){
		console.log(this.$refs.signaturePad);
		return true;
		// return this.$refs.signaturePad.isEmpty();
	}
  }
}
</script>

<style lang="scss">
   #fourth_step{
	.pdf_wrapper{max-height: 200px;overflow-y: scroll;}
	.inner_title{    font-weight: 900;margin: 20px 0;text-decoration: underline;}
	.terms {
		&{display: flex;flex-direction: column;justify-content: center;text-align: initial;}
		.sig_wrapper{
			&{margin-bottom: 20px;}
			.btn_clear_sig{font-size: 16px;text-decoration: underline;}
		}
	}
	.disabled{opacity: 0.5;cursor: no-drop;}
   }
</style>